<template>
    <div class="buy-components">
        <div class="plus-minus">
            <button @click="minus">-</button>
            <span style="margin:0 10px;font-size:22px;color: #5E6D82;">
                      {{countNumber}}
            </span>
            <button @click="plus">+</button>
        </div>
        <div v-if="maxCount > 0">
            <button class="btn btn-primary  btn-big buynow" @click="buyNow">
                {{$t('buy_now')}}
            </button>
            <button class="btn btn-primary btn-hollow btn-big add_cart" @click="addShopCart">
                {{$t('add_to_cart')}}
            </button>
        </div>
        <div v-else>
            <button class="btn btn-gray btn-hollow btn-big buynow">
                {{$t('store_mainpage_out_of_stock')}}
            </button>
            <button class="btn btn-gray btn-hollow btn-big add_cart">
                {{$t('add_to_cart')}}
            </button>
        </div>
    </div>
</template>
<script>
    import Signature from '../../lib/Signature'
    import modal from './Modal.vue'

    export default {
        name: 'buy',
        data () {
            return {
                countNumber: 1
            }
        },
        components: {
            modal
        },
        props: {
            id: Number,
            maxCount: {
                type: Number,
                default: 99
            }

        },
        methods: {
            buyNow () {
                if (this.Local.get('users')=== null) {
                    this.$Message.error(this.$t('user_message_please_login'))
                    this.$busEvent.$emit('login')
                    this.Local.set('CartGoods_number',this.countNumber)
                    this.Local.set('CartGoods_id',this.id)
                }else{
                    this.$router.push({
                        name: 'Settlement',
                        query: {
                            goods_id: this.id,
                            number: this.countNumber
                        }
                    })
                }

            },
            addShopCart () {
                //添加购物车
                const module = 'index.php/index/shopcar/addcart'
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                data.goods_id = this.id,
                data.number = this.countNumber
                data.lang = this.$i18n.locale
                if (!this.Local.isLogin()) {
                    data.tourists_token = this.Local.get('tourists_token')
                }else{
                    data.user_id = this.Local.getUserId()
                }
                this.$http.post(process.env.BASEURL + module, data)
                    .then(function (response) {
                        if (parseInt(response.data.code) === 2000) {
                            this.$Message.success(this.$t('added_successfully'))
                            // 添加到购物车事件
                            this.$busEvent.$emit('addCart', id)
                        }
                    }.bind(this))

            },
            minus () {
                if (this.countNumber <= 1) {
                    return false
                }
                this.countNumber--
            },
            plus () {
                if (this.maxCount <= 1) return false
                if (this.countNumber === this.maxCount) {
                    return false
                }
                this.countNumber++
            }
        }
    }
</script>
<style scoped lang="scss">
    @import "../../scss/common";

    .buy-components {
        .btn{
            margin: 20px 0;
            width: 165px;
        }
        .plus-minus {
            margin: 20px 0 0 0;
            button {
                &:first-child {
                    border-radius: 5px 0 0 5px;
                }
                &:last-child {
                    border-radius: 0 5px 5px 0;
                    background: rgb(0, 132, 255);
                    border: 1px solid rgb(0, 132, 255);
                }
                padding: 0 20px;
                background: #D3DCE6;
                border: 1px solid #D3DCE6;
                color: #fff;
                font-size: 24px;
            }
        }
        .buynow {
            margin-right: 30px;
            @media (max-width: 414px) {
                margin-right: 0px;
            }
        }
    }
    @media (max-width:320px) {
        .buy-components {
            .buynow{
                margin-right: 0px;
            }
            .btn{
                margin: 20px 0 0;
                width: 165px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// Buy.vue?7f0c4c23